import request, { METHODS } from "src/utils/api-base";

const authTenantApis = {
  login: (payload: { email: string; password: string }) => {
    return request({
      route: "/app/auth/login",
      method: METHODS.POST,
      payload,
    });
  },
  getUserDetails: () =>
    request({
      route: "/app/auth/get-user-info",
      method: METHODS.GET,
      auth: true,
    }),
  updateProfile: (payload: {
    firstName: string;
    lastName?: string;
    email: string;
    password?: string;
  }) =>
    request({
      route: "/app/auth/update-profile",
      method: METHODS.PUT,
      payload,
      auth: true,
    }),
  updateCompanyDetails: (payload: {
    gst?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    pincode?: string;
    idPrefixes?: {
      saleOrder?: string;
      purchaseOrder?: string;
      product?: string;
      adjustmentOrder?: string;
      transaction?: string;
      transfer?: string;
    };
    warehouseLabel?: {
      singular?: string;
      plural?: string;
    };
  }) =>
    request({
      route: "/app/auth/company-details",
      method: METHODS.PUT,
      payload,
      auth: true,
    }),
  getPlanUsage: () =>
    request({
      route: "/app/auth/plan-usage",
      method: METHODS.GET,
      auth: true,
    }),
  // Self-serve sign-up wizard: email -> OTP -> org details -> owner details.
  // sendSignupOtp doubles as "resend" (idempotent per email).
  sendSignupOtp: (payload: { email: string }) =>
    request({
      route: "/app/auth/signup/start",
      method: METHODS.POST,
      payload,
    }),
  verifySignupOtp: (payload: { email: string; code: string }) =>
    request({
      route: "/app/auth/signup/verify-otp",
      method: METHODS.POST,
      payload,
    }),
  completeSignup: (payload: {
    email: string;
    organizationName: string;
    organizationIdentifier: string;
    ownerName: string;
    mobile: string;
    password: string;
    warehouseLabelSingular?: string;
    warehouseLabelPlural?: string;
  }) =>
    request({
      route: "/app/auth/signup/complete",
      method: METHODS.POST,
      payload,
    }),
  sendEmailOtp: () =>
    request({
      route: "/app/auth/send-email-otp",
      method: METHODS.POST,
      auth: true,
    }),
  verifyEmailOtp: (payload: { code: string }) =>
    request({
      route: "/app/auth/verify-email-otp",
      method: METHODS.POST,
      payload,
      auth: true,
    }),
  forgotPassword: (payload: { email: string }) =>
    request({
      route: "/app/auth/forgot-password",
      method: METHODS.POST,
      payload,
    }),
  resetPassword: (payload: {
    email: string;
    token: string;
    newPassword: string;
  }) =>
    request({
      route: "/app/auth/reset-password",
      method: METHODS.POST,
      payload,
    }),
  checkEmail: (email: string) =>
    request({
      route: "/app/auth/check-email",
      method: METHODS.GET,
      params: { email },
    }),
  checkIdentifier: (identifier: string) =>
    request({
      route: "/app/auth/check-identifier",
      method: METHODS.GET,
      params: { identifier },
    }),
};

export default authTenantApis;
